{
  "fields": {
    "switch": {
      "on": "Tak",
      "off": "Nie"
    },
    "search": {
      "placeholder": "Szukaj..."
    }
  }
}
